import styled from '@emotion/styled'

import { COLORS } from '@/styles/colors'

export const EditContainer = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  background-color: ${COLORS.bgSubtle};
`

export const EditContents = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  gap: 16px;
  padding: 24px 16px 48px;
  overflow-y: auto;
`

export const EditSection = styled.section`
  display: flex;
  flex-direction: column;
`

export const EditSectionHeading = styled.h2`
  margin: 0;
  padding: 8px 4px 12px;
  font-size: 18px;
  font-weight: 600;
  line-height: 26px;
  letter-spacing: -0.18px;
  color: ${COLORS.textPrimary};
`

export const EditBottomBar = styled.div`
  padding: 12px 16px calc(8px + var(--safe-bottom, 0px));
  background-color: ${COLORS.bgWhite};
`
